import React from 'react';
import PageMeta from '../components/common/PageMeta';

import FeaturesTwo from '../components/selfhosted/featurestwo';
import FeaturesMcp from '../components/features/featuresmcp';
import FeaturesOne from '../components/selfhosted/featuresone';
import FeaturesThree from "../components/selfhosted/featuresthree";
import TrialBanner from "../components/trial/trialbanner";
import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import HeroEightCustom from './HeroEightCustom';
import SectionTitle from '../components/common/SectionTitle';

const HomeAppTwo = () => {
    return (
        <Layout>
            <PageMeta title='SFTP MCP Server | FilePulse' description="We are pleased to open source our new SFTP MCP (ModelContextProtocol) server—allowing seamless exchange between your AI Chat client and an SFTP server using the ModelContextProtocol framework. This solution is designed to support integration with systems that rely on contextual data modeling, ensuring secure, structured, and consistent data transfers. To help you get started and make full use of the platform’s capabilities, we’ve published a comprehensive User Guide covering connection setup, authentication, directory structure, and best practices. " />
            <Navbar navDark />
            <HeroEightCustom>
                Introducing: SFTP MCP Server
            </HeroEightCustom>
            <section className='feature-promo pt-120 pb-20 bg-light'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-10 col-md-10'>
                            <SectionTitle
                                description="We are pleased to open source our new SFTP MCP (ModelContextProtocol) server—allowing seamless exchange between your AI Chat client and an SFTP server using the ModelContextProtocol framework. This solution is designed to support integration with systems that rely on contextual data modeling, ensuring secure, structured, and consistent data transfers. To help you get started and make full use of the platform’s capabilities, we’ve published a comprehensive User Guide covering connection setup, authentication, directory structure, and best practices. 
                            "
                                centerAlign
                            />
                        </div>

                        <div className='col-lg-10 col-md-10'>
                            <SectionTitle
                                subtitle="What is MCP?"
                                description="The Model Context Protocol (MCP) is a specification developed by Anthropic that defines how AI systems—particularly language models—interact with structured context from external tools and environments. At its core, MCP is designed to make models more situationally aware by giving them a standardized, machine-readable way to access relevant information, like documents, files, and workspace context, at inference time.

In practical terms, MCP acts as a bridge between a language model and its surrounding digital environment. Instead of treating each user interaction as an isolated prompt, MCP allows the model to understand the broader context—what project you're working on, which files are open, recent edits, and other developer-relevant metadata. This results in dramatically improved responses, especially in code writing, editing, or debugging scenarios.

Anthropic's implementation of MCP is closely integrated into tools like the Claude desktop app, where developers can connect their own environments or servers (e.g., via SFTP) to feed real-time data into the model’s context window. This creates a more dynamic, intelligent, and personalized interaction between human users and powerful language models.
                            "
                                centerAlign
                            />
                        </div>
                    </div>
                    <div className="row">

                    </div>
                    <div className='row justify-content-center'>
                        <div className="col-md-2">
                            <a href="/post/sftp-mcp-guide-how-to" className="btn btn-primary">
                                SFTP MCP User guide
                            </a>
                        </div>
                    </div>

                </div>
            </section>
            <FeaturesMcp />
            <TrialBanner />
            {/* <FeatureFive />
            <Process />
            <CtaFive /> */}
            <FooterOne footerLight />
        </Layout>
    );
};

export default HomeAppTwo;



